import { jsx as e, jsxs as i } from "react/jsx-runtime";
import * as r from "@radix-ui/react-accordion";
import { ChevronDownIcon as s } from "lucide-react";
import { cn as n } from "../../lib/utils.js";
function m({
  className: o,
  ...t
}) {
  return /* @__PURE__ */ e(
    r.Root,
    {
      "data-slot": "accordion",
      className: n("flex flex-col gap-2", o),
      ...t
    }
  );
}
function u({
  className: o,
  ...t
}) {
  return /* @__PURE__ */ e(
    r.Item,
    {
      "data-slot": "accordion-item",
      className: n(
        "box-border bg-surface-primary border border-neutral-border rounded-xl overflow-hidden hover:bg-action-secondary-hover focus-within:border-utility-focus focus-within:border-[2.5px] data-[state=open]:border-utility-focus data-[state=open]:border-[2.5px] transition-colors",
        o
      ),
      ...t
    }
  );
}
function f({
  className: o,
  children: t,
  ...a
}) {
  return /* @__PURE__ */ e(r.Header, { className: "w-full flex", children: /* @__PURE__ */ i(
    r.Trigger,
    {
      "data-slot": "accordion-trigger",
      className: n(
        "w-full flex items-baseline font-medium leading-6 justify-between transition-all cursor-pointer gap-2 p-3 outline-none [&>svg]:ml-auto [&>svg]:origin-center [&>svg]:transition-transform [&>svg]:duration-300 [&>svg]:ease-out [&[data-state=open]>svg]:rotate-180",
        o
      ),
      ...a,
      children: [
        t,
        /* @__PURE__ */ e(s, { className: "text-neutral-secondary-content pointer-events-none size-4 shrink-0 translate-y-0.5 transition-transform duration-200" })
      ]
    }
  ) });
}
function p({
  className: o,
  children: t,
  ...a
}) {
  return /* @__PURE__ */ e(
    r.Content,
    {
      "data-slot": "accordion-content",
      className: "data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down overflow-hidden text-sm",
      ...a,
      children: /* @__PURE__ */ e("div", { className: n("pt-0 px-4 pb-4", o), children: t })
    }
  );
}
export {
  m as Accordion,
  p as AccordionContent,
  u as AccordionItem,
  f as AccordionTrigger
};
